import { RecurringPaymentDetails } from './payment.model';

// nls-rework\src\app\models\loan.model.ts
/**
 * Represents the current status of a loan
 */
export enum LoanGeneralStatusCode {
  Active = 0,
  Closed = 1
}

/**
 * Payment settings for a loan
 */
export interface PaymentSettings {
  readonly recurringPaymentExists: boolean;
  readonly existingRecurringPaymentDisabled: boolean;
  readonly disableCardPayment: boolean;
  readonly disableBankingPayment: boolean;
  readonly disableCardRecurringPayment: boolean;
  readonly disableBankingRecurringPayment: boolean;
}

/**
 * View model for displaying loan card information
 */
export interface LoanCard {
  readonly id: number;
  readonly number: string;
  readonly nickname: string;
  readonly payoffBalance: number;
  readonly pastDue: number;
  readonly pastDueDate: Date | null;
  readonly nextPaymentDueAmount: number;
  readonly nextPaymentDueDate: Date;
  readonly setupDate: Date;
  readonly statusCode: LoanGeneralStatusCode;
  readonly isSelected: boolean;
  readonly portfolio_code_id?: number;
}

/**
 * View model for displaying detailed loan information
 */
export interface LoanDetail {
  readonly number: string;
  readonly nickname: string;
  readonly openDate: Date;
  readonly maturityDate: Date | null;
  readonly loanAmount: number;
  readonly principal: number;
  readonly interest: number;
  readonly fees: number;
  readonly lateCharges: number;
  readonly otherCharges: number;
  readonly totalBalance: number;
  readonly currentImpound: number;
  readonly lastPayment: number | null;
  readonly lastPaymentReceivedDate: Date | null;
  readonly currentRate: number;
  readonly interestPaidYTD: number;
  readonly creditLineLimit: number;
  readonly payoffAmount: number;
  readonly payoffDate: Date;
  readonly nextPaymentDueAmount: number;
  readonly nextPaymentDueDate: Date;
  readonly paymentSettings: PaymentSettings;
  readonly recurringPayment: RecurringPaymentDetails | null;
  readonly statusCode: LoanGeneralStatusCode;
  readonly portfolio_code_id?: number;
}

/**
 * View model for loan statement information
 */
export interface LoanStatement {
  readonly statementDate: Date;
  readonly statementDueDate: Date | null;
  readonly pastDueBalance: number;
  readonly currentBalance: number;
  readonly currentPayoff: number;
  readonly documentId: number;
}

/**
 * View model for loan statements page
 */
export interface LoanStatements {
  readonly primaryStatement: LoanStatement | null;
  readonly statements: LoanStatement[];
  readonly hasStatements: boolean;
}
